<template>
<div class="row">
    <h2 class="center">Наличие товара на складе компании LIGA SOUND</h2>
    <app-alert v-if="error"></app-alert>

    <b-card no-body v-if="!error && !search"> 
        <b-tabs pills card>
            <b-tab v-for="item in ost" :key="item.Code" :title="item.Name" title-link-class="myost-link">
                
                <b-card no-body v-if="item.Elements[0].IsFolder" >    
                    <b-tabs  pills card> 
                        <b-tab v-for="el in item.Elements" :key="el.Code" :title="el.Name" title-link-class="myost-link">

                            <b-card no-body v-if="el.Elements[0].IsFolder">
                                <b-tabs  pills card>
                                    <b-tab v-for="t in el.Elements" :key="t.Code" :title="t.Name" title-link-class="myost-link">
                                        <my-tab v-if="!t.Elements[0].IsFolder" :items="t.Elements"></my-tab>

                                        <b-card no-body v-if="t.Elements[0].IsFolder">
                                            <b-tabs  pills card>
                                                <b-tab v-for="q in t.Elements" :key="q.Code" :title="q.Name" title-link-class="myost-link">
                                                    <my-tab v-if="!q.Elements[0].IsFolder" :items="q.Elements"></my-tab>
                                                </b-tab>
                                            </b-tabs>
                                        </b-card>

                                    </b-tab>
                                </b-tabs>
                            </b-card>
                            <my-tab v-if="!el.Elements[0].IsFolder" :items="el.Elements"></my-tab>

                        </b-tab>
                    </b-tabs>
                </b-card>
                <my-tab v-if="!item.Elements[0].IsFolder" :items="item.Elements"></my-tab>
            </b-tab>
        </b-tabs>
    </b-card>

    <b-btn block variant="outline-primary" class="mb-3" v-if="!error" @click="search = !search">{{ !search ? 'Поиск' : 'Закрыть поиск'}}</b-btn>
    <div class="search" v-if="search">
        <input class="form-control" placeholder="Введите строку для поиска минимум 3 символа" v-model="searchStr" />
        <p v-if="SearchArr && SearchArr.length == 0 && searchStr.length > 2" class="form-control">По Вашему запросу ни чего не найдено</p>

        <my-tab v-if="SearchArr && SearchArr.length !=0" :items=SearchArr></my-tab>
    </div>

</div>
</template>

<script>
import Vue from 'vue'

import AppAlert from '../components/AppAlert'
import MyTab from '../components/MyTab'

let qar = []

function qq(arr) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].IsFolder) {
            qq(arr[i].Elements)
        } else {
            qar.push(arr[i])
        }

    }
    return qar
}

export default {

    data() {
        return {
            ost: [],
            error: true,
            search: false,
            searchStr: ''

        }
    },
    created() {
        Vue.http.get('1.json')
            .then(res => {
                
                let ost = res.body
                this.ost = ost
                this.error = false
            })
    },
    computed: {
        Arr() {
            return qq(this.ost)
        },
        SearchArr() {
            let sarr = []
            if (this.searchStr.length > 2) {
                for (let i = 0; i < this.Arr.length; i++) {
                    let name = this.Arr[i].Name.toLowerCase()
                    if (name.indexOf(this.searchStr.toLowerCase()) != -1) {
                        sarr.push(this.Arr[i])
                    }
                }
                return sarr
            }

        }

    },
    methods: {
        log(el){
            console.log(el)
        }
    },

    components: {
        MyTab,
        AppAlert
    }
}
</script>

<style>
h2.center {
    text-align: center;
    width: 100%;
}

a.myost-link {
    color: #000;
}

a.myost-link:hover {
    background: lightgrey !important;
    color: #ffffff;
}

a.myost-link.active {
    color: #fff !important;
    background-color: #564D76 !important;
}

.card-body {
    padding: 1rem 0 0 0 !important;
}

.search {
    width: 100%;
}
</style>
